import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import NotificationSystem from "react-notification-system";
import {css} from "@emotion/core";
import {style} from "variables/Variables.jsx";
import axios from "axios";
import jwt_decode from 'jwt-decode';
import {confirmAlert} from "react-confirm-alert";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import AsyncPaginate from 'react-select-async-paginate';
import {BeatLoader} from 'react-spinners';
import Autocomplete from 'react-autocomplete';
import ReactTags from 'react-tag-autocomplete'
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
var provalData= [];
class MdataMerchantV2 extends Component{
    constructor(props) {
        super(props);
        this.state={
            _notificationSystem: null,
            pricing_logic: [{
                objectLabel: "a",
                objectID: "",
                objectName: "",
                objectType: "",
                objectTime: "",
                stageName: "",
                stage: "",
                stageDes: "",
                stageList: "",
                config: [{
                    configID: "",
                    config_id: "",
                    config_value: [],
                    config_valueList: [],
                    configTable: "",
                    configList: "",
                    in_notin: "IN"
                }],
                object_value: "",
                excel_grouping:"",
                object_value_type: "abs",
                start_data: "",
                pro_data_mid: true,
                apply_pricing: true,
                measureLists: [{value: '', label: 'None'}],
                measureVal: "",
                aggrLists:"",
                aggr_id: ""
            }],
            max_month_price: [{ max_month_options: "Store",  max_month_value:""}],
            per_terminal_if: 'abs',
            per_transaction_if:'abs',
            per_card_if: 'abs',
            per_store_if: 'abs',
            currency_list:'INR',
            table: true,
            merchantList:[{value:'', label: 'All'}],
            chainList:[{value:'', label: 'All'}],
            GSTList:[],
            merchantID:'',
            chainID:'',
            storeList:[],
            storeID:'',
            deleteKeys:[],
            deleteKeys1:[],
            min_month_options_list:[],
            max_month_options_list:[],
            usr_type: 'Merchant',
            acq_bank_list:[],
            acq_bank_id:'',
            pricing_rule_name:'',
            approve:[],
            viewMode:false,
            startDate: new Date(),
            endDate: new Date(year + 1, month, day),
            view_rule_id:null,
            version:1,
            object:[],
            loading :false,
            loading1: false,
            allStageLists:[],
            allConfigLists:[],
            rulesData:[],
            checkedRules: [],
            checkedEmails: [],
            name_code:'',
            gst_id:'',
            counter_party_name:'',
            gst_code:'',
            storeList1:[],
            items: [],
            counterPartyList:[],
            partyTable:'',
            partyID:'',
            searchBy:'',
            partyTableName:'',
            service_id:'',
            serviceLists:[],
            scheme_id:'',
            schemeLists:[],
            propertiesLists:[],
            property_id:'',
            propertiesvalues:[{value:'', label: 'None'}],
            loading2: false,
            p_logic:'',
            merchant_for_chain:'',
            merchant_for_store:'',
            chain_for_store:'',
            merchant_for_party:[],
            chain_for_party:[],
            approve_per: false,
            tags: [],
            suggestions: [
                {id: 3, name: "Bananas"},
                {id: 4, name: "Mangos"},
                {id: 5, name: "Lemons"},
                {id: 6, name: "Apricots"}
            ],
            // party_id_for_gst_others:'',
            party_id_for_gst_store:''
        }
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };


    componentDidMount() {
        var that = this;
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        //this._get_pricing_rule_variables();
        this._getAllRules('');
        //this._getMerchants();
        this._getCounterPartyType();
        // this._get_acq_banks();
        this.approvalPermission();
        this.getApprovers();

        this._get_services();
        this._selectRules(that);
        this._viewSelectedRules(that);
    }
    sendNotification(notification){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/users/notifications/',{
                user:decoded._id,
                msg: notification,
                AllApprovers: this.state.AllApprovers,
                user_name:decoded.firstName+' '+decoded.lastName
            }, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

        }).then(response => {


        });
    }
    _viewSelectedRules(that) {
        $('#mdata').on('click', 'td.actionTd #actButton', function() {
            var rule_id = $(this).data("rule");

            $.ajax({
                url:config.get('API_URL')+ "/masterdata/view_rule/?rule_id="+rule_id,
                type: 'GET',
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) { //console.log(response);
                    var objectsArray = [];
                    if(Array.isArray(response.robData) && response.robData.length) {
                        response.robData.map((str, index1) => {
                            var pro_rata = true;
                            if (str.pro_rata_enabled == 0) {
                                pro_rata = false
                            }
                            var apply_pricing = true;
                            if (str.apply_pricing == 0) {
                                apply_pricing = false
                            }
                            var mname = '';
                            if (str.meData!=null && Object.keys(str.meData).length !== 0 && str.meData.constructor === Object) {
                                //if(str.meData.length>0){
                                mname = str.meData.measure_name
                            }
                            //alert(mname);
                            objectsArray.push({
                                objectLabel: str.object_label,
                                objectID: str.object_id,
                                aggr_id: str.aggregator_id,
                                objectName: str.obData.object_name,
                                objectType: str.obData.object_type,
                                objectTime: str.stData.stage_attribute_min_bound,
                                stageName: str.stData.stage_name,
                                stage: str.stage_id,
                                stageDes: str.stData.stage_description,
                                stageList: "",
                                config: [],
                                object_value: str.object_value,
                                excel_grouping:str.excel_grouping,
                                object_value_type: str.value_type,
                                start_data: "",
                                pro_data_mid: pro_rata,
                                apply_pricing: apply_pricing,
                                measureLists: [{value: '', label: 'None'}],
                                measureVal: [{value: str.measure_id, label: mname}]
                            });
                            str.opData.map((str1, index) => {
                               //console.log(str1.popData.property_table);
                                var tagArray = []
                                str1.property_value.map((strtag, index1) => {
                                    tagArray.push({
                                        id: strtag, name: strtag
                                    })
                                });
                                objectsArray[index1].config.push({
                                    configID: str1.property_id,
                                    config_id: str1.popData.property_attribute,
                                    config_value: tagArray,
                                    config_valueList: [],
                                    in_notin: str1.comparison_logic,
                                    configTable: str1.popData.property_table,
                                    configList: "",

                                });
                                that.get_object_config(str.object_id, index1);
                            });
                            that.get_object_stage(str.object_id, index1);
                            that.get_object_aggr(str.object_id, index1)
                            that.get_object_mesure(str.object_id, index1);
                        });
                    }


                    that.changeParty(response.party_id+'##'+response.partyName.party_attribute+'##'+response.partyName.party_name,'edit','');

                    //that.changeParty(response.party_id+'##'+"edw_dim.dw_dim_merchant.merchant_id"+'##'+response.partyName.party_name,'');
                    that.changeService('view',response.service_id,'');
                    // console.log("llllllllllllllllll");
                    // console.log(response.gstData);
                    var gstd = [];
                    if(response.gstData.length>0){
                        response.gstData.map((value, index) => {
                            var is_exi = gstd.some(item => item.value === value.gstValData.master_gst);
                            if(is_exi===false) {
                                gstd.push({value: value.gstValData.master_gst, label: value.gstValData.master_gst})
                            }

                        })
                    }

                    that.setState({
                        partyID:response.party_id,
                        pricing_rule_type: response.pricing_logic,
                        partyTable:response.partyName.party_attribute.id+'.'+response.partyName.party_attribute.name,
                        partyName:response.partyName.party_name,
                        storeVal : {"value":'', "label":response.party_name},
                        GSTList: gstd,
                        gstValue: gstd,
                        property_attribute: response.ppData.length ? response.ppData[0].propName.property_attribute : '',
                        property_id: response.ppData.length ? response.ppData[0].property_id : '',
                        propertyValue: {value: response.ppData.length ? response.ppData[0].property_value : '', label: response.ppData.length ? response.ppData[0].property_value : ''},
                        des_content: response.rule_description,
                        startDate: response.valid_from,
                        endDate: response.valid_till,
                        service_id: response.service_id,
                        scheme_id: response.scheme_id,
                        pricing_logic: objectsArray,
                        p_logic: response.pricing_logic,
                        viewMode:true,
                    });
                }
            });
        })
    }

    _selectRules(that){
        $('#mdata').on('click', 'td.selectRule #checkbox', function() {
            var rule_id = $(this).data("rule_id");
            var rule_email = $(this).data("rule_email");
            let item_list = that.state.checkedRules;
            let checked_list = rule_id;
            let item_list_email = that.state.checkedEmails;
            let checked_list_email = rule_email;
            if($(this).is(':checked')===true) {
                that.setState({
                    checkedRules: [...that.state.checkedRules, rule_id ],
                    checkedEmails: [...that.state.checkedEmails, rule_email ]
                });
            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    that.setState({
                        checkedRules: item_list,
                    })
                }
                let index1 = item_list_email.indexOf(checked_list_email);
                if (index1 > -1) {
                    item_list_email.splice(index1, 1);
                    that.setState({
                        checkedEmails: item_list_email,
                    })
                }
            }
        });
    }

    _get_services(){
        axios.get(config.get('API_URL')+'/masterdata/get-services/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                this.setState({
                    serviceLists: response.data,
                })
            }

        }).catch(err =>{
            console.log(err);
        })
    }

    _getCounterPartyType(){
        this.setState({
            loading: true
        });
        axios.get(config.get('API_URL')+'/masterdata/get-counter-party-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {

            var vPartyList=response.data;
            vPartyList.sort((a,b) => (a.party_id > b.party_id) ? 1 : ((b.party_id > a.party_id) ? -1 : 0));
            this.setState({
                counterPartyList: vPartyList,
                partyTable:vPartyList[0].party_attribute.id+'.'+vPartyList[0].party_attribute.name,
                partyID: vPartyList[0].party_id,
                partyName: vPartyList[0].party_name,
                loading: false
            });
            this._getPartyProperties(response.data[0].party_id);
            this.get_objects(response.data[0].party_id,'');
            var m_party = [];
            var c_party = [];
            vPartyList.map((party, index) =>{
                if(party.party_name=='Merchant'){
                    m_party.push(party.party_id);
                }
                if(party.party_name=='Chain'){
                    m_party.push(party.party_id);
                    c_party.push(party.party_id);
                }
                if(party.party_name=='Store'){
                    m_party.push(party.party_id);
                    c_party.push(party.party_id);
                    this.setState({
                        party_id_for_gst_store:party.party_id
                    })
                }

                // console.log(c_party)
                this.setState({
                    merchant_for_party: m_party,
                    chain_for_party: c_party
                })
            })
        }).catch(err =>{
            console.log(err);
        })
    }

    changeParty(flag,act, e){
        if(flag==''){
            if(e.target.value==''){
                return false;
            }
        }
        this.setState({
            partyTable:'',
            storeList:[],
            loading: true
        });

        if(flag==''){
            var nameArr = e.target.value.split('##');
        }
        else {
            var nameArr = flag.split('##');
        }

        var table = nameArr[1].split('.');
        this.setState({
            partyID:nameArr[0],
            nameVal: '',
            partyTable:nameArr[1],
            loading: false,
            partyName: nameArr[2],
            usr_type: nameArr[2],
        });

        this.get_objects(nameArr[0], act);
        this._getPartyProperties(nameArr[0]);
    }

    _getPartyProperties(val){
        axios.get(config.get('API_URL')+'/masterdata/get-party-property/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                party_id: val
            }
        }).then(response => {
            this.setState({
                propertiesLists: response.data
            })

        }).catch(err =>{
            console.log(err);
        })
    }

    _getPartyNameList = async (table_names, search, loadedOptions, { page } ) => {
        var id_col = '';
        var code_col = '';
        let table_schema = '';
        let table_name = '';
        var table_column = '';
        var table = table_names.split('.');
        //console.log(table);
         if(table.length>0)
            {
                table_schema=table[0];
                table_name=table[1];
                id_col=table[2];
                table_column=table[5];
            }

        if(table_name=='dw_dim_merchant') {
           code_col = 'merchant_code';
        }
        else if(table_name=='dw_dim_chain') {
            code_col = 'chain_code';
        }
        else if(table_name=='dw_dim_store') {
           code_col = 'store_code';
        }

        else if(table_name=='dw_dim_acquiring_bank') {
           code_col = 'acq_bank_code';
        }
        else if(table_name=='dw_dim_issuing_bank') {
           code_col = 'issuing_bank_id';
        }

        this.setState({
            storeList:[]
        });

        let res = await axios.get(config.get('API_URL')+"/masterdata/get-party-name/?table_schema="+table_schema+"&table_name="+table_name+"&table_column="+table_column+"&search="+search+"&page="+page+"&code_col="+code_col+"&id_col="+id_col, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        });

        let hasMore = false;
        if(Array.isArray(res.data) && res.data.length) {
            hasMore = true;
        }
        // console.log("mmmmmmmmmmmmmmmmmmmmmmmmm");
        // console.log(res.data);
        res.data.map((str,index) => {
            //this.state.storeList.push({value: str[id_col]+'##'+str[code_col]+'##'+str[table_column], label: str[table_column]})
            this.state.storeList.push({value: str.value+'##'+str.code+'##'+str.label, label: str.label})
        });
        return {
            options: this.state.storeList,
            hasMore: hasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    changeProperties(e){
        var proArr = e.target.value.split('##');
        var pro_id = proArr[0];
        var pro_table = proArr[1];

        var table1 = proArr[1].split('.');
        var schemaName = table1[0];
        var tableName = table1[1];
        var tableAttr =  table1[2];
        this.setState({
            propertiesvalues:[{value:'', label: 'None'}],
            loading2:true,
            property_id: pro_id,
            property_attribute: pro_table
        });

        axios.get(config.get('API_URL')+'/masterdata/get-property-value/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                schema_name: schemaName,
                table_name: tableName,
                table_column: tableAttr
            }
        }).then(response => { //console.log("propertival"); console.log(response);
            response.data.map((conf,index) => {
                this.state.propertiesvalues.push({value: conf[tableAttr], label: conf[tableAttr]})
            });
            this.setState({
                loading2:false,
            })

        }).catch(err =>{
            console.log(err);
        })
    }

    _getAllRules(code) {
        //if ($.fn.DataTable.isDataTable('#mdata')) {
         //   $('#mdata').DataTable().destroy();
        //}
        var cls = '';
        $("#checkbox").prop("checked", false);
        const token = localStorage.usertoken;
        let decoded_str = jwt_decode(token);
        if ($.fn.DataTable.isDataTable('#mdata')) {
            $('#mdata').DataTable().destroy();

        }
        var data = {
            code: code
        }
        var ruleList = $('#mdata').DataTable(
            {
                order: [],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo": false,
                //"autoWidth": false,
                "responsive": false,
                //"sPaginationType": "numbers",
                "scrollX": true,
                fixedColumns:   {
                                leftColumns: 2,
                                rightColumns: 1
                            },
                "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],

                ajax: {
                    url: config.get('API_URL') + "/masterdata/get_all_new_rules",
                    type: "POST",
                    data: data,
                    dataSrc: function (json) { //console.log(json.data);
                        return json.data;
                    },
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

                columns: [
                    {"data": "rule_id"},
                    {"data": "sku"},
                    {"data": "rule_name"},
                    {"data": "party_type"},
                    {"data": "party_name"},
                    {"data": "property_name"},
                    {"data": "property_value"},
                    {"data": "pricing_logic"},
                    {"data": "rule_description"},
                    {"data": "valid_from"},
                    {"data": "valid_till"},
                    {"data": "appr_status"},
                    {"data": "updated_by"},
                    {"data": "approved_by"},
                    {"data": "rule_id"},
                ],
                "columnDefs": [
                    {
                        render: function (data, type, row) {
                            return '<td><input type="checkbox" id="checkbox" name="per_rule_price" data-rule_id="'+row.rule_id+'" data-rule_email="'+row.updated_by+'" /></td>';

                        },
                        className: "selectRule",
                        targets: 0,
                        aTargets: [-1]
                    },
                    {
                        render: function (data, type, row) {

                            return '<td><a href="#" data-toggle="tooltip" title='+JSON.stringify(data)+'><i class="fa fa-info-circle" aria-hidden="true"></i></a></td>';

                        },

                        className: "",
                        targets: 8,
                        aTargets: [-1]
                    },
                    {
                        "targets": 11,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {//console.log(rowData.Status);
                            //console.log(td);
                            if (rowData.appr_status == 'approved') {
                                $(td).addClass('doneLog');
                            }
                            else {
                                $(td).addClass('stopedLog');
                            }

                        },
                    },

                    {
                        render: function (data, type, row) {
                            return '<td><a href="#" data-tip="View Rule" class="btn btn-default actionBtn" role="button" id="actButton" data-rule='+row.rule_id+'><i class="fa fa-eye" aria-hidden="true"></i></td>';

                        },
                        className: "actionTd",
                        targets: 14,
                        aTargets: [-1]
                    },

                ]

            });
        // axios.get(config.get('API_URL')+'/masterdata/get_all_new_rules/',{
        //     headers: {
        //         Authorization: ` ${localStorage.usertoken}`
        //     },
        //     params:{
        //         code: code
        //     }
        // }).then(response => {
        //     if(!response.data.error) {
        //         if(Array.isArray(response.data) && response.data.length) {
        //             this.setState({
        //                 rulesData: response.data,
        //             })
        //         }
        //         else{
        //             this.setState({
        //                 rulesData: [],
        //             })
        //         }
        //     }
        //     if ($.fn.DataTable.isDataTable('#mdata')) {
        //         $('#mdata').DataTable().clear().destroy();
        //     }
        //     $('#mdata').DataTable(
        //         {
        //         scrollX:        true,
        //         //scrollCollapse: true,
        //         // paging:         false,
        //         fixedColumns:   {
        //             leftColumns: 2,
        //             rightColumns: 1
        //         }
        //     }
        //     );
        // }).catch(err =>{
        //     console.log(err);
        // })
    }

    get_objects(party_id, act) {
        axios.get(config.get('API_URL')+'/masterdata/pricing-objects/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                party_id: party_id
            }
        }).then(response => {

            // console.log(response.data);
            // console.log(response.data[0].partyObjData.object_id);
            if(Array.isArray(response.data) && response.data.length) {
                this.setState({
                    object: response.data,
                    objID: response.data[0].partyObjData.object_id
                });
            } else{
                this.setState({
                    object: response.data,
                    objID: 0
                });
            }
            // this.get_object_stage(response.data[0].object_id, 0);
            // this.get_object_config(response.data[0].object_id, 0);
            if(act!='edit'){
                this.setState({
                    pricing_logic: [{
                        objectLabel: "a",
                        objectID: "",
                        objectName: "",
                        objectType: "",
                        objectTime: "",
                        stageName: "",
                        stage: "",
                        stageDes: "",
                        stageList: "",
                        config: [{
                            configID: "",
                            config_id: "",
                            config_value: [],
                            config_valueList: [],
                            configTable: "",
                            configList: "",
                            in_notin: "IN"
                        }],
                        object_value: "",
                        excel_grouping:"",
                        object_value_type: "abs",
                        start_data: "",
                        pro_data_mid: true,
                        apply_pricing: true,
                        measureLists: [{value: '', label: 'None'}],
                        measureVal: "",
                        aggrLists:"",
                        aggr_id: ""
                    }],
                })
            }

        });
    }

    get_object_config(id, idx) {
        axios.get(config.get('API_URL')+'/masterdata/pricing-objects-config/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                object_id: id
            }
        }).then(response => {
            const newDataStores1 = this.state.pricing_logic.map((dataStore, sidx) => {
                const stt = dataStore.config.map((dataStore1, sidx1) => {
                    if (idx !== sidx) return dataStore1;
                    let configData = response.data.map((conf,index) => {
                        return (
                            <option key={index + 1}
                                    value={conf.property_table + '##' + conf.property_attribute + '##' + conf.property_id}>{conf.property_display_name}</option>
                        )
                    });
                    this.setState({allConfigLists: configData  });
                    return { ...dataStore1, configList: configData };
                });
                // console.log("pppppppp")
                // console.log(stt);
                return { ...dataStore, config: stt };
            });
            this.setState({ pricing_logic: newDataStores1 });
        });
    }

    changeIn(idx, idx1, evt) {
        //var strArrayConf = evt.target.value.split("##");

        //alert(evt.target.value);

        const new_conf_val = this.state.pricing_logic.map((dataStore, sidx) => {
            if (idx !== sidx) return dataStore;
            const ds = dataStore.config.map((dataStore1, sidx1) => {
                if (idx1 !== sidx1) return dataStore1;
                return {...dataStore1, in_notin: evt.target.value};
            });

            return {...dataStore, config: ds};
        });
        this.setState({pricing_logic: new_conf_val});

    }
    changeConf(idx, idx1, evt){

        var strArrayConf = evt.target.value.split("##");

        //alert(strArrayConf[0]);

        const new_conf_val = this.state.pricing_logic.map((dataStore, sidx) => {
            if (idx !== sidx) return dataStore;
            const ds = dataStore.config.map((dataStore1, sidx1) => {
                if (idx1 !== sidx1) return dataStore1;
                return { ...dataStore1, configID: strArrayConf[2], config_id: strArrayConf[1], configTable: strArrayConf[0] };
            });
            // console.log("pppppppp")
            // console.log(stt);
            return { ...dataStore, config: ds };
        });
        this.setState({ pricing_logic: new_conf_val });
        // const new_conf_val = this.state.pricing_logic.map((conf_val, sidx) => {
        //     if (idx !== sidx) return conf_val;
        //     return { ...conf_val, config: evt.target.value };
        // });
        // //this.get_object_config(evt.target.value, idx);
        // this.setState({ pricing_logic: new_conf_val });
        //this.get_config_value(idx, idx1, strArrayConf[0], strArrayConf[2] );
    }

    // get_config_value = async (idx, idx1, table_column, table_name, search, loadedOptions=[], { page }) => {
    //     console.log(table_column); //alert(table_name);
    //
    //     this.setState({
    //         storeList1:[]
    //     })
    //     let res = await axios.get(config.get('API_URL')+"/masterdata/object-config-value/?table_column="+table_column+"&table_name="+table_name+"&search="+search+"&page="+page, {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //     });
    //     let hasMore = false;
    //     if(Array.isArray(res.data) && res.data.length) {
    //         hasMore = true;
    //     }
    //     console.log("rewwwwwwwwwww"); console.log(res);
    //     res.data.map((str,index) => {
    //         this.state.storeList1.push({value: str[table_column], label: str[table_column]})
    //     })
    //
    //     return {
    //         options: this.state.storeList1,
    //         hasMore: hasMore,
    //         additional: {
    //             page: page + 1,
    //         },
    //     };
    //  };
    // get_config_value(idx, idx1, table_column, table_name){
    //     //alert(table_column); alert(table_name);
    //     axios.get(config.get('API_URL')+'/masterdata/object-config-value/',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             table_column: table_column,
    //             table_name: table_name
    //         }
    //     }).then(response => { console.log("listttttVal"); console.log(response.data);
    //         const newDataStores12 = this.state.pricing_logic.map((dataStore, sidx) => {
    //             if (idx !== sidx) return dataStore;
    //             const stt1 = dataStore.config.map((dataStore1, sidx1) => {
    //                 if (idx1 !== sidx1) return dataStore1;
    //                 let configData = response.data.map((conf,index) => {
    //                     return (
    //                         <option value={conf[table_column]}>{conf[table_column]}</option>
    //                     )
    //                 });
    //
    //                 return { ...dataStore1, config_valueList: configData };
    //             });
    //             // console.log("pppppppp")
    //             // console.log(stt);
    //             return { ...dataStore, config: stt1 };
    //         });
    //         this.setState({ pricing_logic: newDataStores12 });
    //     });
    // }

    changeValue(idx, idx1, evt){
        const new_conf_val1 = this.state.pricing_logic.map((dataStore, sidx) => {
            if (idx !== sidx) return dataStore;
            const ds = dataStore.config.map((dataStore1, sidx1) => {
                if (idx1 !== sidx1) return dataStore1;
                return { ...dataStore1, config_value: evt.target.value};
            });
            return { ...dataStore, config: ds };
        });
        this.setState({ pricing_logic: new_conf_val1 });

    }

    changeStage(idx, evt){
        var strArray = evt.target.value.split("##");
        const new_stage_val = this.state.pricing_logic.map((new_stage, sidx) => {
            if (idx !== sidx) return new_stage;
            return { ...new_stage, stage: strArray[0], stageName:strArray[1], stageDes:strArray[2], objectTime: strArray[3]  };
        });
        //this.get_object_config(evt.target.value, idx);
        this.setState({ pricing_logic: new_stage_val });
    }

    changeAggr(idx, evt){

        const new_aggr_val = this.state.pricing_logic.map((new_aggr, sidx) => {
            if (idx !== sidx) return new_aggr;
            return { ...new_aggr, aggr_id: evt.target.value };
        });
        //this.get_object_config(evt.target.value, idx);
        this.setState({ pricing_logic: new_aggr_val });
    }

    get_object_stage(id, idx){
        axios.get(config.get('API_URL')+'/masterdata/pricing-objects-stage/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                object_id: id
            }
        }).then(response => {
            const newDataStores1 = this.state.pricing_logic.map((dataStore, sidx) => {
                if (idx !== sidx) return dataStore;
                let stageData = response.data.map((stage,index) => {
                    return (
                        <option key={index+1} value={stage.stage_id+'##'+stage.stage_name+'##'+stage.stage_description+'##'+stage.stage_attribute_min_bound}>{stage.stage_name}</option>
                    )
                });
                this.setState({allStageLists: stageData  });
                return { ...dataStore, stageList: stageData };
            });
            this.setState({ pricing_logic: newDataStores1 });

        });
    }
    get_object_aggr(id, idx){
        axios.get(config.get('API_URL')+'/masterdata/pricing-objects-aggr/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                object_id: id
            }
        }).then(response => {
            const newDataStores1 = this.state.pricing_logic.map((dataStore, sidx) => {
                if (idx !== sidx) return dataStore;
                let aggrData = response.data.map((aggr,index) => {
                    return (
                        <option key={index+1} value={aggr.aggregator_id}>{aggr.aggregator_display_name}</option>
                    )
                });
               // this.setState({allStageLists: aggrData  });
                return { ...dataStore, aggrLists: aggrData };
            });
            this.setState({ pricing_logic: newDataStores1 });

        });
    }

    changeObject(idx, evt){
        var strArrayObj = evt.target.value.split("##");
        let ex_grp = 1;
        if(strArrayObj[1]==='UTID' || strArrayObj[1]==='BTID'){
            ex_grp = 1;
        }
        else if(strArrayObj[1]==='Transaction'){
            ex_grp = 2;
        }
        const new_min_month = this.state.pricing_logic.map((min_month, sidx) => {
            if (idx !== sidx) return min_month;
            return { ...min_month, objectID: strArrayObj[0], objectName: strArrayObj[1], objectType: strArrayObj[2], excel_grouping:ex_grp };
        });

        this.get_object_stage(strArrayObj[0], idx);
        this.get_object_aggr(strArrayObj[0], idx);
        this.get_object_config(strArrayObj[0], idx);
        if(strArrayObj[2]=='fact') {
            this.get_object_mesure(strArrayObj[0], idx);
        }
        this.setState({ pricing_logic: new_min_month });
    }

    get_object_mesure(id, idx){
        axios.get(config.get('API_URL')+'/masterdata/pricing-objects-measure/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                object_id: id
            }
        }).then(response => { //console.log("mesureeeeeeeeee"); console.log(response);
            var measureLists = [{value:'', label: 'None'}];
            // let mattr  = response.data.measure_attribute;
            // let mattrArray = mattr.split(".");
            // let t_name = mattrArray[0];
            // let t_attr = mattrArray[1];
            //this.get_object_mesure_lists(id, idx,t_name,t_attr)
            const newDataStores1 = this.state.pricing_logic.map((dataStore, sidx) => {
                if (idx !== sidx) return dataStore;
                response.data.map((conf,index) => {
                    measureLists.push({value: conf.measure_id, label: conf.measure_name})
                });
                // this.setState({measureLists: stageData  })
                return { ...dataStore, measureLists: measureLists };
            });
            this.setState({ pricing_logic: newDataStores1 });

        }).catch(err =>{
            console.log(err);
        })
    }

    get_object_mesure_lists(id, idx,t_name,t_attr){

       var measureLists = [{value:'', label: 'None'}];

        axios.get(config.get('API_URL')+'/masterdata/pricing-objects-measure-lists/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                table_name: t_name,
                table_column: t_attr
            }
        }).then(response => {
            const newDataStores1 = this.state.pricing_logic.map((dataStore, sidx) => {
                if (idx !== sidx) return dataStore;
                response.data.map((conf,index) => {
                    measureLists.push({value: conf[t_attr], label: conf[t_attr]})
                });
               // this.setState({measureLists: stageData  })
                return { ...dataStore, measureLists: measureLists };
            });
            this.setState({ pricing_logic: newDataStores1 });

        });
    }

    // _getMerchants() {
    //     this.setState({
    //         merchantList:[{value:'', label: 'Select'}],
    //         loading:true
    //     })
    //     axios.get(config.get('API_URL')+'/invoice/all-merchants/',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         response.data.map((merchant,index) => {
    //             this.state.merchantList.push({value: merchant.merchant_id+'_'+merchant.merchant_code+'_'+merchant.merchant_name, label: merchant.merchant_name})
    //         });
    //         this.setState({
    //            loading:false
    //         })
    //     });
    // }
    // _getChain(){
    //     this.setState({
    //         merchantList:[{value:'', label: 'Select'}],
    //         loading:true
    //     })
    //     axios.get(config.get('API_URL')+'/invoice/all-chain/',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         response.data.map((merchant,index) => {
    //             this.state.merchantList.push({value: merchant.chain_id+'_'+merchant.chain_code+'_'+merchant.chain_name, label: merchant.chain_name})
    //         });
    //         this.setState({
    //             loading:false
    //         })
    //     });
    // }
    //
    // _get_acq_banks(){
    //     this.setState({
    //         merchantList:[{value:'', label: 'Select'}],
    //         loading:true
    //     })
    //     axios.get(config.get('API_URL')+'/invoice/all_acq_banks/',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //     }).then(response => {
    //         response.data.map((merchant,index) => {
    //             this.state.merchantList.push({value: merchant.acquiring_bank_id, label: merchant.acq_bank_name})
    //         });
    //     });
    //     this.setState({
    //         loading:false
    //     })
    // }
    // _get_issuing_banks(){
    //     this.setState({
    //         merchantList:[{value:'', label: 'Select'}],
    //         loading:true
    //     })
    //     axios.get(config.get('API_URL')+'/invoice/all_issuing_banks/',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //     }).then(response => {
    //         response.data.map((merchant,index) => {
    //             this.state.merchantList.push({value: merchant.issuing_bank_id, label: merchant.issuing_bank_name})
    //         });
    //     });
    //     this.setState({
    //         loading:false
    //     })
    // }

    getApprovers(){
        axios.get(config.get('API_URL')+'/users/get_all_approvers/',{
        }).then(response => {
            // console.log("allapprovers");
            // console.log(response);
            this.setState({
                AllApprovers: response.data,
            })
        });
    }

    approvalPermission(){
        const token = localStorage.usertoken;
        let approvalPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllaccessPermissions = decoded_permission.accessPermissions;
        AllaccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Function'){
                approvalPermissions.push(permissionName.access_name);
            }
        });
        if(approvalPermissions.includes("approve_pricing_rule")===true){
            this.setState({
               approve_per: true
            })
        }
        this.setState({
            approvalPermissions:approvalPermissions,

        })
    }


    get_id_byEmail(id, checked, email){
        axios.get(config.get('API_URL')+'/users/get_user_by_email/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                email: email
            }
        }).then(response => {
            this.setState({
                view_uid: response.data.id
            });
            this.changeRule(id, checked, email, response.data.id);
        })
    }

    changeGst(optionSelected){
        let value='';
        let gstArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((gsts, i) => {
                gstArray.push(gsts.value)
            });
        }

        this.setState({
            gstValue: optionSelected,
            gst_id: gstArray
        });


        // axios.get(config.get('API_URL')+'/masterdata/get_gst_code/',{
        //     headers: {
        //         Authorization: ` ${localStorage.usertoken}`
        //     },
        //     params: {
        //         gst: value
        //     }
        // }).then(response => {
        //     this.setState({
        //         gst_code: response.data.gst_code
        //     });
        //
        // })
    }

    changeMeasure(idx, optionSelected,evt){
        const value = optionSelected === null ? '' : optionSelected.value;
        const new_min_month = this.state.pricing_logic.map((min_month, sidx) => {
            if (idx !== sidx) return min_month;
            return { ...min_month, measureVal:optionSelected };
        });

        this.setState({ pricing_logic: new_min_month });
    }

    changePropValue(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;

        this.setState({
            propertyValue: optionSelected,
            property_value: value
        });

    }

    changePartyName(optionSelected){

        const value = optionSelected === null ? '' : optionSelected.value;
        if(value!='') {
            var strArray = value.split("##");
            //console.log(value);
            var sid = new Array();
            sid = strArray[0].split(",");
            var name_code = new Array();
            name_code = strArray[1].split(",");
            this.setState({
                storeVal: optionSelected,
                sid: sid,
                gstValue: '',
                name_code: name_code,
                counter_party_name: strArray[2]
            });
            //alert(strArray[2]);
            this.get_gst_no(sid, name_code, strArray[2]);
        }
        else {
            this.setState({
                storeVal: optionSelected,
                sid: sid,
                gstValue: '',
                name_code: '',
                counter_party_name: '',
                GSTList:[]
            });
        }

        if(this.state.usr_type=='Chain') {
            //alert("Chain"); alert(sid);
            axios.get(config.get('API_URL')+'/masterdata/get_merchant_code/',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params:{
                    chain_code: name_code
                }
            }).then(response => {
                this.setState({
                    merchant_for_chain: response.data[0].merchant_code,
                })
            });
        } else if(this.state.usr_type=='Store') {
            //alert("Store"); alert(sid);
            axios.get(config.get('API_URL')+'/masterdata/get_merchant_chain/',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params:{
                    store_code: name_code
                }
            }).then(response => {
                this.setState({
                    merchant_for_store:response.data[0].merchant_code,
                    chain_for_store: response.data[0].chain_code,
                })
            });
        }
        if(name_code===undefined || name_code =='undefined')
        {
            name_code = '';
        }
        this._getAllRules(name_code);
    }

    handleAddMinKey(idx, arrayLenght, e) {
        e.preventDefault();
        var obLabel = (arrayLenght+10).toString(36);
        this.setState({
            pricing_logic: this.state.pricing_logic.concat([{
                objectLabel: obLabel,
                objectID: "",
                objectName: "",
                objectType: "",
                objectTime: "",
                stageName: "",
                stage: "",
                stageDes: "",
                stageList: "",
                config: [{
                    configID: "",
                    config_id: "",
                    config_value: [],
                    config_valueList: [],
                    configTable: "",
                    configList: "",
                    in_notin: "IN"
                }],
                object_value: "",
                excel_grouping:"",
                object_value_type: "abs",
                start_data: "",
                pro_data_mid: true,
                apply_pricing: true,
                measureLists: [{value: '', label: 'None'}],
                measureVal: "",
                aggrLists:"",
                aggr_id: ""
            }])
        });
        //this.get_object_stage(1,1)
    }

    handleAddMaxKey(idx, stage_id, e){
        e.preventDefault();
        const newDataStores2 = this.state.pricing_logic.map((dataStore, sidx) => {
            if (idx !== sidx) return dataStore;
            this.get_object_config(stage_id, idx);
            return {
                ...dataStore,
                config: dataStore.config.concat([{
                    configID: "",
                    config_id: "",
                    config_value: [],
                    config_valueList: [],
                    configTable: "",
                    configList: "",
                    in_notin: "IN"
                }])
            };
        });
        this.setState({ pricing_logic: newDataStores2 });
    }

    handleRemoveMinKey = idx => (e) => {
        e.preventDefault();
        // if(this.state.pricing_logic[idx].id!=""){
        //     this.state.deleteKeys.push(this.state.pricing_logic[idx].id);
        // }
        this.setState({
            pricing_logic: this.state.pricing_logic.filter((s, sidx) => idx !== sidx)
        });
    };

    handleRemoveMaxKey(e, idx, idx1) {
        e.preventDefault();
        const newDataStores3 = this.state.pricing_logic.map((dataStore, sidx) => {
            // console.log("llllll");
            // console.log(dataStore.config);
            if (idx !== sidx) return dataStore;
            return { ...dataStore, config: dataStore.config.filter((s, sidx1) => idx1 !== sidx1)};
        });
        this.setState({ pricing_logic: newDataStores3 });
    }
    checkRule(e){

        if(this.state.counter_party_name ==''){
            this.handleNotificationClick("tr", 3, "Please Select Counter Party Name.");
            return false;
        }
        if(this.state.service_id ==''){
            this.handleNotificationClick("tr", 3, "Please Select a service.");
            return false;
        }
        if(this.state.scheme_id ==''){
            this.handleNotificationClick("tr", 3, "Please Select a scheme.");
            return false;
        }
        axios.post(config.get('API_URL')+'/masterdata/check-rule/',
            {
                  partyID: this.state.partyID,
                  merchant_for_chain: this.state.merchant_for_chain,
                  merchant_for_store: this.state.merchant_for_store,
                  chain_for_store: this.state.chain_for_store,
                  service_id: this.state.service_id,
                  scheme_id: this.state.scheme_id,
                  counter_party_id: this.state.name_code,
                  counter_party: this.state.usr_type,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                if(Array.isArray(response.data) && response.data.length<1) {
                    this.is_valid_rule();
                    //this.addRule();
                } else {
                    this.handleNotificationClick("tr", 3, "This rule is already exists.");
                }

                //
            })
            .catch(err => {
                console.log(err);

            })

    }

    is_valid_rule() {
        var objLabel = [];
        this.state.pricing_logic.map((label, index) => {
            objLabel.push(label.objectLabel);
        });
        axios.post(config.get('API_URL') + '/masterdata/check-valid-rule/',
            {
                pricing_logic: this.state.pricing_rule_type,
                pricing_object_labels: objLabel,

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                if (response.data.data === true) {
                    // this.is_valid_rule();
                    this.addRule();
                } else {
                    this.handleNotificationClick("tr", 3, "Invalid pricing Rule.");
                }

                //
            })
            .catch(err => {
                console.log(err);

            })

    }
    addRule(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(this.state.counter_party_name ==''){
            this.handleNotificationClick("tr", 3, "Please Select Counter Party Name.");
            return false;
        }
        if(this.state.service_id ==''){
            this.handleNotificationClick("tr", 3, "Please Select a service.");
            return false;
        }
        if(this.state.scheme_id ==''){
            this.handleNotificationClick("tr", 3, "Please Select a scheme.");
            return false;
        }
        var saveData = this.state.pricing_logic;
        // console.log('saveData');
        // console.log(saveData);
        for(var i = 0; i < saveData.length; i++) {
            delete saveData[i].stageList;
            delete saveData[i].aggrLists;
            for(var j = 0; j < saveData[i].config.length; j++) {
                delete saveData[i].config[j].config_valueList;
                delete saveData[i].config[j].configList;
            }
        }

        // console.log('nsaveData');
        // console.log(saveData);

        axios.post(config.get('API_URL')+'/masterdata/save_new_pricing_data/',
            {
                user_email:decoded.email,
                user:decoded._id,
                partyID: this.state.partyID,
                valid_from:this.state.startDate,
                valid_till:this.state.endDate,
                gst_no: this.state.gst_id,
                description: this.state.des_content,
                pricing_logic:saveData,
                AllApprovers: this.state.AllApprovers,
                status:'pending-approval',
                user_name:decoded.firstName+' '+decoded.lastName,
                name_code: this.state.name_code,
                billing_gsts: this.state.GSTList,
                counter_party: this.state.usr_type,
                counter_party_name: this.state.counter_party_name,
                counter_party_id: this.state.sid,
                gst_code: this.state.gst_code,
                property_id:this.state.property_id,
                property_value:this.state.propertyValue,
                service_id: this.state.service_id,
                scheme_id: this.state.scheme_id,
                version:1,
                latestversion:true,
                p_logic: this.state.p_logic,
                pricing_rule_type: this.state.pricing_rule_type,
                merchant_for_chain: this.state.merchant_for_chain,
                merchant_for_store: this.state.merchant_for_store,
                chain_for_store: this.state.chain_for_store,
                party_id_for_gst_store: this.state.party_id_for_gst_store
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                if(response.data.error) {
                    this.handleNotificationClick("tr", 3, "Error..!!!");
                }
                else {
                    this.sendNotification(response.data.ruleName)
                    this.clearForm();
                    this.handleNotificationClick("tr", 1, "Data Submitted Successfully..!!!");
                    this._getAllRules('');
                }
                $("#checkbox").removeAttr('checked');

            })
            .catch(err => {
                console.log(err);
                this.handleNotificationClick("tr", 3, "Error..!!!");
            })

    }

    clearForm(){
        this.setState({
            usr_type: 'Merchant',
            nameVal:'',
            gstValue:[],
            GSTList:[],
            storeVal:'',
            des_content:"",
            name_code:'',
            service_id:'',
            scheme_id:'',
            partyID:'',
            partyName:'',
            partyTable:'',
            pricing_rule_type:'',
            pricing_logic: [{
                objectLabel: "a",
                objectID: "",
                objectName: "",
                objectType: "",
                objectTime: "",
                stageName: "",
                stage: "",
                stageDes: "",
                stageList: "",
                config: [{
                    configID: "",
                    config_id: "",
                    config_value: [],
                    config_valueList: [],
                    configTable: "",
                    configList: "",
                    in_notin: "IN"
                }],
                object_value: "",
                excel_grouping:"",
                object_value_type: "abs",
                start_data: "",
                pro_data_mid: true,
                apply_pricing: true,
                measureLists: [{value: '', label: 'None'}],
                measureVal: "",
                aggrLists:"",
                aggr_id: ""
            }],
            valid_from: new Date(),
            valid_till: new Date(),
            propertiesLists:[],
            property_attribute:'',
            property_id:'',
            propertyValue:null,
            propertiesvalues:[]

        });

       this._getCounterPartyType();
    }

    changeDes(e){
        this.setState({des_content:e.target.value})
    }

    handleFromChange = date => {
        // var aa = date.format('yyyy-MM-dd');

        this.setState({
            startDate: date
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: date
        });
    };

    onPerTransactionIf(idx, e){
        const tr_type = this.state.pricing_logic.map((type, sidx) => {
            if (idx !== sidx) return type;
            return { ...type, object_value_type: e.target.value };
        });
        this.setState({ pricing_logic: tr_type });
    }


    changeConfigText(e){
        this.setState({
            ctype: e.target.value,
        })
    }

    get_gst_no(value, code, partyName){ //alert(value);
         //alert(code);
        this.setState({
            GSTList:[],
            loading1:true,
        });
        var GstArrayList=[];
        axios.post(config.get('API_URL')+'/invoice/get_gst_number/', {
                id: value,
                code: code,
                type:this.state.usr_type,
                partyID: this.state.partyID,
                merchant_for_party: this.state.merchant_for_party,
                chain_for_party: this.state.chain_for_party,
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((gst, index) => {
                    //if(this.state.usr_type=='Acquiring Bank' || this.state.usr_type=='Issuing Bank') {
                        this.state.GSTList.push({value: gst.id, label: gst.master_gst});
                    // }
                    // else {
                    //     this.state.GSTList.push({value: gst.billing_gst_number, label: gst.billing_gst_number});
                    // }
                    //GstArrayList.push(gst.billing_gst_number);
                });
            }
            //this.get_all_gst_code(GstArrayList);
            this.setState({
                loading1:false
            })
        })
    }

    get_all_gst_code(gstNo){
        // console.log("gstNo");
        // console.log(gstNo);
        axios.post(config.get('API_URL')+'/masterdata/get_all_gst_code/',{
                gst_numbers : gstNo
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

        })
    }


    changeObjectValue(idx, e){
        const plogic = this.state.pricing_logic.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, object_value: e.target.value };
        });
        this.setState({ pricing_logic: plogic });
    }

    changeExcelGrouping(idx, e){
        const plogic = this.state.pricing_logic.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, excel_grouping: e.target.value };
        });
        this.setState({ pricing_logic: plogic });
    }

    viewRule(e,ruleSku){
        e.preventDefault();

        this.clearForm();
        axios.get(config.get('API_URL')+'/masterdata/view_rule/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                ruleSku: ruleSku
            }
        }).then(response => {
            // console.log("singleRule");
            // console.log(response.data);
            var rName = response.data.rule_name;
            var v_disp = rName.split("-");

            this.setState({
                usr_type: v_disp[0],
                gstValue: {value:response.data.gst, label: response.data.gst},
                des_content: response.data.rule_desc,
                startDate: response.data.valid_from,
                endDate: response.data.valid_to,
               // pricing_logic: [{ objectLabel:"a", objectID: "", objectName:"", objectType: "", objectTime:"", stageName:"", stage:"", stageDes:"", config:[ {configID:"", config_id:"", config_value:"", configTable:""}], object_value:"", excel_grouping:"",object_value_type:"abs", start_data:"", pro_data_mid:true, measureLists:[{value:'', label: 'None'}], measureVal:"" }],
            })

        }).catch(err =>{
            console.log(err);
        })

    }
    handleCheck(sku, email, i, e) {
        let item_list = this.state.checkedRules;
        let checked_list = sku;
        let item_list_email = this.state.checkedEmails;
        let checked_list_email = email;
        if(e.target.checked===true) {
            this.setState({
                checkedRules: [...this.state.checkedRules, sku ],
                checkedEmails: [...this.state.checkedEmails, email ]
            });
        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                this.setState({
                    checkedRules: item_list,
                })
            }
            let index1 = item_list_email.indexOf(checked_list_email);
            if (index1 > -1) {
                item_list_email.splice(index1, 1);
                this.setState({
                    checkedEmails: item_list_email,
                })
            }
        }

    }

    approveAll() {
        if(Array.isArray(this.state.checkedRules) && this.state.checkedRules.length){
            confirmAlert({
                title: 'Question',
                message: 'Are you sure you want to approve selected Rules?.',
                buttons: [{
                    label: 'Yes',
                    onClick: () => {
                        this.approveRules();
                    }
                },
                    {
                        label: 'No',
                    }

                ]
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please Select Rules.");
        }

    }

    approveRules(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/masterdata/approve-rule-v2/',{
                rule_ids : this.state.checkedRules,
                user_email: decoded.email,
                created_user_email: this.state.checkedEmails,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this._getAllRules('');
            //this.sendNotificationToUser(this.state.checkedRules);

            $("#checkbox").prop("checked", false);
            this.setState({
                checkedRules: [],
                checkedEmails: []
            });
            this.handleNotificationClick("tr", 1, "Rules has been successfully approved.");
        })
    }
    sendNotificationToUser(rules){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/users/approve_notifications/',{
            user:decoded._id,
            rule: rules,
            user_name:decoded.firstName+' '+decoded.lastName
        }, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {


        });
    }
    deleteAll() {
        if(Array.isArray(this.state.checkedRules) && this.state.checkedRules.length){
            confirmAlert({
                title: 'Question',
                message: 'Are you sure you want to delete selected Rules?.',
                buttons: [{
                    label: 'Yes',
                    onClick: () => {
                        this.deleteRules();
                    }
                },
                    {
                        label: 'No',
                    }

                ]
            });
        } else {
            this.handleNotificationClick("tr", 3, "Please Select Rules.");
        }

    }

    deleteRules(){
        axios.post(config.get('API_URL')+'/masterdata/delete-rule-v2/',{
                skus : this.state.checkedRules
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this._getAllRules('');
            $("#checkbox").prop("checked", false);
            this.handleNotificationClick("tr", 1, "Rules has been successfully Deleted.");
            //this._getAllRules();
            this.setState({
                checkedRules: [],
                checkedEmails: [],

            })
        })
    }
    changeService(type, val, e){
        var sid = '';
        if(type == 'view') {
            sid= val;
        }
        else {
            sid= e.target.value;
        }
        this.setState({
            service_id: sid
        });
        this._getScheme(sid);
    }
    _getScheme(val){
        axios.get(config.get('API_URL')+'/masterdata/get-scheme/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{
                service_id : val
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                this.setState({
                    schemeLists: response.data,
                })
            }
            else {
                this.setState({
                    schemeLists: [],
                })
            }


        }).catch(err =>{
            console.log(err);
        })
    }
    changeScheme(e){
        this.setState({
            scheme_id: e.target.value
        })
    }

    onChangeData(idx, idx1, pr_id, table_attr, propID, query) {
        // console.log("hsdgfgsdfsf");
        // console.log(query);
        // console.log(table_attr);
        var tnameArr = table_attr.split('.');

        var table_name = tnameArr[0]+'.'+tnameArr[1];
        var table_column = pr_id;
        var prop_value = query;


        this.setState({
            value: query,
            //pricing_logic: [{ objectID: "", objectName:"", stageName:"", stage:"", stageDes:"", stageList:"", config:[ {configID:"", config_id:"", config_value:"", config_valueList:[{ id: '1', label: 'foo' },{ id: '2', label: 'bar' }, { id: '3', label: 'baz' }], configTable:"", configList:""}], p_logic:"", p_logic_type:"Abs"}],
        });

        axios.get(config.get('API_URL')+'/masterdata/object-config-value/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                table_attr: table_attr,
                table_column: table_column,
                table_name: table_name,
                prop_value: prop_value,
                obj_prop_id: propID
            }
        }).then(response => {
            // console.log("listttttVal" + table_column);
            // console.log(response);
            const newDataStores12 = this.state.pricing_logic.map((dataStore, sidx) => {
                if (idx !== sidx) return dataStore;
                const stt1 = dataStore.config.map((dataStore1, sidx1) => {
                    if (idx1 !== sidx1) return dataStore1;

                    let configData = [];
                    if(Array.isArray(response.data.data) && response.data.data.length) {
                        response.data.data.map((conf, index) => {
                            configData.push({id: conf[table_column].toString(), name: conf[table_column]})

                        });
                    }

                    return {...dataStore1, config_valueList: configData};
                });

                return { ...dataStore, config: stt1 };
            });
            this.setState({ pricing_logic: newDataStores12 });
        });
    }


    handleAddition(idx, idx1, tag) {
        //console.log("oppppppppp");
        // console.log(tag);
        // console.log(idx); console.log(idx1);
        // const tags = [].concat(this.state.pricing_logic[idx].config[idx1].config_value, tag)
        //
        // this.setState({ tags })
        const newDataStores2 = this.state.pricing_logic.map((dataStore, sidx) => {
            if (idx !== sidx) return dataStore;

            //return { ...dataStore, config: dataStore.config.concat([{configID:"", config_id:"", config_value:[], config_valueList:[], configTable:"", configList:""}]) };
            const stt1 = dataStore.config.map((dataStore1, sidx1) => {
                if (idx1 !== sidx1) return dataStore1;

                return {...dataStore1, config_value: dataStore1.config_value.concat(tag)};
            });

            return {...dataStore, config: stt1};
        });
        this.setState({pricing_logic: newDataStores2});
    }

    handleDelete(idx, idx1, i) {
        // console.log(this.state.pricing_logic[idx].config[idx1].config_value)
        const tags = this.state.pricing_logic[idx].config[idx1].config_value.slice(0)
        tags.splice(i, 1)
        this.setState({tags})
        //     console.log("abbbbbb");
        // console.log(tags);
        // this.setState({ tags })

        const newDataStores2 = this.state.pricing_logic.map((dataStore, sidx) => {
            if (idx !== sidx) return dataStore;

            //return { ...dataStore, config: dataStore.config.concat([{configID:"", config_id:"", config_value:[], config_valueList:[], configTable:"", configList:""}]) };
            const stt1 = dataStore.config.map((dataStore1, sidx1) => {
                if (idx1 !== sidx1) return dataStore1;


                return {...dataStore1, config_value: tags};
            });

            return {...dataStore, config: stt1};
        });
        this.setState({pricing_logic: newDataStores2});
    }
    onSelectData(idx, idx1, val){
        const new_conf_vals = this.state.pricing_logic.map((dataStore, sidx) => {
            if (idx !== sidx) return dataStore;
            const ds = dataStore.config.map((dataStore1, sidx1) => {
                if (idx1 !== sidx1) return dataStore1;

                return { ...dataStore1, config_value: val };
            });
            // console.log("pppppppp")
            // console.log(stt);
            return { ...dataStore, config: ds };
        });
        this.setState({ pricing_logic: new_conf_vals });
    }
    changeProdata(idx, e){
        const prata = this.state.pricing_logic.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return { ...logic, pro_data_mid: e.target.checked };
        });
        this.setState({ pricing_logic: prata });

    }

    changeApplyPr(idx, e) {
        const prata = this.state.pricing_logic.map((logic, sidx) => {
            if (idx !== sidx) return logic;
            return {...logic, apply_pricing: e.target.checked};
        });
        this.setState({pricing_logic: prata});

    }

    changeRuleType(e){
        this.setState({
            pricing_rule_type:e.target.value
        })
    }
    changePricingLogic(e){
        this.setState({
            p_logic:e.target.value
        })
    }

    render() {
        // console.log(this.state.pricing_logic);
        //  console.log(this.state.checkedRules)
        var merchantPagignate='';
        var chainPagignate='';
        var storePagignate='';
        var acqPagignate='';
        var issuPagignate = '';
        var otherPagignate = '';

        const customStyles = {
            // control: provided => ({
            //     ...provided,
            //     padding:"0px",
            //     minHeight: "15px",
            // }),
            // indicatorsContainer: provided => ({
            //     ...provided,
            //     height: "23px"
            // }),
            // clearIndicator: provided => ({
            //     ...provided,
            //     padding: "5px"
            // }),
            // dropdownIndicator: provided => ({
            //     ...provided,
            //     padding: "5px"
            // }),
            // valueContainer: base => ({
            //     ...base,
            //     padding: '0px 6px'
            // }),
        };

        const menuStyle = {
            borderRadius: '3px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '2px 2px',
            fontSize: '90%',
            overflow: 'auto',
            maxHeight: '300px', // TODO: don't cheat, let it flow to the bottom
            "zIndex": 9999,
            position: 'absolute',
            top: '30px',
            left: 0,

        };

        let obj = this.state.object.map((object, index) =>{
            return (
                <option value={object.partyObjData.object_id+'##'+object.partyObjData.object_name+'##'+object.partyObjData.object_type} key={index+1}>{object.partyObjData.object_name}</option>
            )
        });

        let partyList = this.state.counterPartyList.map((party, index) =>{
            var atr_id = '';
            if(party.party_attribute==null){
                return (
                    <option value="" key={index+1}>{party.party_name}</option>
                )
            }
            else {
                return (
                    <option value={party.party_id+'##'+party.party_attribute.id+'.'+party.party_attribute.name+'##'+party.party_name} key={index+1}>{party.party_name}</option>
                )
            }

        });
        let serviceList = this.state.serviceLists.map((service, index) =>{
            return (
                <option value={service.service_id} key={index+1}>{service.service_name}</option>
            )
        });
        let pLists =  this.state.propertiesLists.map((pro, index) =>{
            return (
                <option value={pro.property_id+'##'+pro.property_attribute} key={index+1}>{pro.property_name}</option>
            )
        });
        let scLists =  this.state.schemeLists.map((pro, index) =>{
            return (
                <option value={pro.scheme_id} key={index+1}>{pro.scheme_name}</option>
            )
        });

        if(this.state.partyName=='Merchant') {

            merchantPagignate = (

                <AsyncPaginate name="stores"
                               value={this.state.storeVal}
                               styles={customStyles} className="partyNameList"
                               isClearable={true}
                               onChange={this.changePartyName.bind(this)}
                               loadOptions={this._getPartyNameList.bind(this, this.state.partyTable)}
                               additional={{
                                   page: 1,
                               }}

                               placeholder="Select Party Name"
                />
            )

        }
        else if(this.state.partyName=='Chain') {

            chainPagignate = (
                <AsyncPaginate name="stores"
                               value={this.state.storeVal}
                               styles={customStyles} className="partyNameList"
                               isClearable={true}
                               onChange={this.changePartyName.bind(this)}
                               loadOptions={this._getPartyNameList.bind(this, this.state.partyTable)}
                               additional={{
                                   page: 1,
                               }}

                               placeholder="Select Party Name"
                />
            )
        }
        else if(this.state.partyName=='Store') {
            storePagignate = (
                <AsyncPaginate name="stores"
                               value={this.state.storeVal}
                               styles={customStyles} className="partyNameList"
                               isClearable={true}
                               onChange={this.changePartyName.bind(this)}
                               loadOptions={this._getPartyNameList.bind(this, this.state.partyTable)}
                               additional={{
                                   page: 1,
                               }}

                               placeholder="Select Party Name"
                />
            )
        }
        else if(this.state.partyName=='Acquiring Bank') {
            acqPagignate = (
                <AsyncPaginate name="stores"
                               value={this.state.storeVal}
                               styles={customStyles} className="partyNameList"
                               isClearable={true}
                               onChange={this.changePartyName.bind(this)}
                               loadOptions={this._getPartyNameList.bind(this, this.state.partyTable)}
                               additional={{
                                   page: 1,
                               }}

                               placeholder="Select Party Name"
                />
            )
        }
        else if(this.state.partyName=='Issuing Bank') {
            issuPagignate = (
                <AsyncPaginate name="stores"
                               value={this.state.storeVal}
                               styles={customStyles} className="partyNameList"
                               isClearable={true}
                               onChange={this.changePartyName.bind(this)}
                               loadOptions={this._getPartyNameList.bind(this, this.state.partyTable)}
                               additional={{
                                   page: 1,
                               }}

                               placeholder="Select Party Name"
                />
            )
        } else {
            otherPagignate = (
                <AsyncPaginate name="stores"
                               value={this.state.storeVal}
                               styles={customStyles} className="partyNameList"
                               isClearable={true}
                               onChange={this.changePartyName.bind(this)}
                               loadOptions={this._getPartyNameList.bind(this, this.state.partyTable)}
                               additional={{
                                   page: 1,
                               }}

                               placeholder="Select Party Name"
                />
            )
        }


        // let tabledata = this.state.rulesData.map((val,index) => {
        //
        //     var cls = '';
        //     var appr_status = ''; var gsts = '';
        //     if(val.status=='approved'){
        //         cls= "doneLog";
        //         appr_status='Approved';
        //     }
        //     else {
        //         cls = 'stopedLog';
        //         appr_status = 'Pending'
        //     }
        //     if(val.gstData.length>0){
        //         gsts = val.gstData[0].gstValData.master_gst;
        //     }
        //     return (
        //         <tr key={index + 1}>
        //             <td className="selectRule"><input type="checkbox" id="checkbox" name="per_rule_price" data-rule_id={val.rule_id} data-rule_email={val.updated_by} data-rule_index={index} /></td>
        //             <td width="150px">{val.sku}</td>
        //             <td>{val.rule_name}</td>
        //             <td>{val.partyName.party_name}</td>
        //             <td>{val.party_name}</td>
        //             <td>{ val.ppData.length  ? val.ppData[0].propName.property_name : ''}</td>
        //             <td>{ val.ppData.length   ? val.ppData[0].property_value : ''}</td>
        //             <td>{val.pricing_logic}</td>
        //             <td>
        //                 <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
        //                 <a href="#" data-tip={val.rule_description}  role="button"  >
        //                 <i className="fa fa-info-circle" aria-hidden="true"></i>
        //                 </a>
        //             </td>
        //             {/*<td>{gsts}</td>*/}
        //             <td>{val.valid_from}</td>
        //             <td>{val.valid_till}</td>
        //             <td className={cls}>{appr_status}</td>
        //             <td>{val.updated_by}</td>
        //             <td>{val.approved_by}</td>
        //             <td className="actionTd" onClick={this.viewRule.bind(this,val.rule_id)}>
        //                 <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
        //                 <a href="#" data-tip="View Rule" className="btn btn-default actionBtn" role="button" id="actButton" data-rule={val.rule_id}>
        //                     <i className="fa fa-eye" aria-hidden="true"></i>
        //                 </a>
        //             </td>
        //         </tr>
        //     )
        //
        // });

        return(

            <div className="row ">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div>
                    <div className="col-md-12 "> <h5>Billing Details :</h5></div>
                    <div className="col-md-3">
                        <label> Counter Party Type: </label>

                        <select name="usr_type" value={this.state.partyID+'##'+this.state.partyTable+'##'+this.state.partyName} className="form-control chainList"
                                onChange={this.changeParty.bind(this, '', 'add')}>
                            {/*<option value="">Select Party</option>*/}
                            {partyList}
                        </select>

                    </div>

                    <div className="col-md-3">
                        <label> Counter Party Name: </label>
                            <div>
                                {merchantPagignate}
                                {chainPagignate}
                                {storePagignate}
                                {acqPagignate}
                                {issuPagignate}
                                {otherPagignate}
                            </div>
                    </div>

                    <div className="col-md-3">
                        <label>Billing GST Number:</label>
                        <div>
                            {this.state.loading1===true?
                                <div className='sweet-loading'>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={10}
                                        color={'#123abc'}
                                        loading={this.state.loading1}
                                    />
                                </div>:
                                <ReactMultiSelectCheckboxes name="gst"
                                        value={this.state.gstValue}
                                        styles={customStyles} className="partyNameList"
                                        isClearable={false}
                                        onChange={this.changeGst.bind(this)}
                                        options={this.state.GSTList}
                                        //defaultValue={{ label: "All", value: '' }}
                                        placeholderButtonLabel="All"
                                    // placeholder="All"
                                />}
                        </div>

                    </div>
                    <div className="clearfix"></div>
                    <div className="gap_ver"></div>
                    <div className="col-md-3">
                        <label> Counter Party Property: </label>
                        <select name="property_id" value={this.state.property_id+'##'+this.state.property_attribute} className="form-control chainList"
                                onChange={this.changeProperties.bind(this)}>
                            <option value="">None</option>
                            {pLists}
                        </select>

                    </div>
                    <div className="col-md-3">
                        <label> Counter Party Property Value: </label>
                        {this.state.loading2===true?
                            <div className='sweet-loading'>
                                <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={10}
                                    color={'#123abc'}
                                    loading={this.state.loading2}
                                />
                            </div>:

                            <Select name="pvalue"
                                    value={this.state.propertyValue}
                                    styles={customStyles} className="partyNameList"
                                    isClearable={false}
                                    onChange={this.changePropValue.bind(this)}
                                    options={this.state.propertiesvalues}
                                    defaultValue={{ label: "None", value: '' }}
                                // placeholder="All"
                            />}
                    </div>
                    <div className="gap_ver"></div>
                </div>
                <div>
                    <div className="clearfix"></div>
                    <div className="gap_ver"></div>
                    <div>
                        <div className="col-md-9">
                            <label>
                                Description:
                            </label>
                            <div className="">
                                        <textarea name = "des_content" rows="4" placeholder="" id="formControlsTextarea" onChange={this.changeDes.bind(this)}
                                                  className="form-control pricingDescription" value={this.state.des_content}>
                                        </textarea>
                            </div>

                            <div className="clearfix"></div>
                        </div>
                        <div className="col-md-3">
                            <label>Valid From</label>
                            <DatePicker
                                dateFormat="yyyy-MM-dd"
                                selected={Date.parse(this.state.startDate)}
                                onChange={this.handleFromChange}
                            />
                            <label>Valid Till</label>

                            <DatePicker
                                dateFormat="yyyy-MM-dd"
                                selected={Date.parse(this.state.endDate)}
                                onChange={this.handleToChange}
                            />

                        </div>

                    </div>
                    <div className="clearfix"></div>
                    <div className="gap_ver"></div>
                    <div className="hoz-line"></div>
                    <div className="col-md-2">
                        <h5>Service :</h5>
                    </div>
                    <div className="col-md-3">
                        <div className="gap_ver"></div>
                        <select name="service_id" value={this.state.service_id} className="form-control chainList"
                                onChange={this.changeService.bind(this,'','')}>
                            <option value="">Select Services</option>
                            {serviceList}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <div className="gap_ver"></div>
                        <select name="scheme_id" value={this.state.scheme_id} className="form-control chainList"
                                onChange={this.changeScheme.bind(this)}>
                            <option value="">Select Scheme</option>
                            {scLists}
                        </select>
                    </div>

                    <div className="clearfix"></div>
                    <div className="gap_ver"></div>
                    <div className="hoz-line"></div>
                    <div className="col-md-12 no-padd">
                        <h5>Pricing Logic :</h5>
                        <div className="priceing_rule">
                            {this.state.pricing_logic.map((pricing_val, idx) => (
                                                                <div className="rule-container" key={idx+1}>
                                    {/*<div>*/}
                                    <div className="col-md-1 padd-2">
                                        {idx==0?<div className="objectLablel"><label>&nbsp;</label></div>:null}
                                        <div className="Rule-al">
                                        {idx>0?
                                            <a href="#" onClick={this.handleRemoveMinKey(idx,this)}
                                               className="addmore_rulesp"
                                            ><i className="fa fa-trash" aria-hidden="true"></i>
                                            </a>:<a href="#" onClick={this.handleAddMinKey.bind(this, idx+1, this.state.pricing_logic.length)}
                                                    className="addmore_rulesp-plus"
                                            ><span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                            </a>}
                                        {/*{idx==0?<div><label>&nbsp;</label></div>:null}*/}
                                        &nbsp;rule {'('+pricing_val.objectLabel+')'}
                                        </div>
                                    </div>
                                    <div className="col-md-1 padd-2">
                                        {idx==0?<div className="objectLablel"><label>Object</label></div>:null}
                                        <select name="objectList" className="form-control chainList left_text" value={pricing_val.objectID+"##"+pricing_val.objectName+"##"+pricing_val.objectType}
                                                onChange={this.changeObject.bind(this, idx)}>
                                            <option value="">Select</option>
                                            {obj}
                                        </select>
                                    </div>

                                    <div className="col-md-1 padd-2">
                                        {idx==0?<div className="objectLablel"><label>Object Stage</label></div>:null}
                                        <select name="stage_type" className="form-control chainList" value={pricing_val.stage+"##"+pricing_val.stageName+"##"+pricing_val.stageDes+"##"+pricing_val.objectTime}
                                                onChange={this.changeStage.bind(this, idx)}>
                                            <option value="">None</option>
                                            {pricing_val.stageList}
                                        </select>
                                        {pricing_val.stageDes!=='null'&& pricing_val.stageDes!==null?
                                            <div className="stage-des">{pricing_val.stageDes}</div>:
                                            <div></div>
                                        }
                                    </div>
                                    <div className="col-md-3 padd-2">
                                        {this.state.pricing_logic[idx].config.map((configuration_val, idx1) => (
                                            <div key={idx1+1}>

                                                <div className="col-md-7 m-bottom-5 padd-2">
                                                    {idx1==0 && idx==0?<div className="objectLablel"><label>Object Property</label></div>:null}
                                                    {idx1>0?
                                                        <a href="#" onClick={ (e) => this.handleRemoveMaxKey(e, idx, idx1)}
                                                           className="addmore_rulesp"
                                                        ><i className="fa fa-trash" aria-hidden="true"></i>
                                                        </a>:<a href="#" onClick={this.handleAddMaxKey.bind(this, idx, pricing_val.objectID)}
                                                                className="addmore_rulesp"
                                                        ><span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                        </a>}
                                                    {configuration_val.config}
                                                    <select name="in_notin"
                                                            className="form-control chainList left_text1 width-35-right"
                                                            value={configuration_val.in_notin}
                                                            onChange={this.changeIn.bind(this, idx, idx1)}>
                                                        <option value="IN">IN</option>
                                                        <option value="NOT IN">NOT IN</option>
                                                    </select>
                                                    <select name="confID"
                                                            className="form-control chainList left_text1 width-50"
                                                            value={configuration_val.configTable + "##" + configuration_val.config_id + "##" + configuration_val.configID}
                                                            onChange={this.changeConf.bind(this, idx, idx1)}>
                                                        <option value="">None</option>
                                                        {configuration_val.configList}
                                                    </select>

                                                </div>


                                                <div className="col-md-5 autoInput padd-2 autoCompleteInp">
                                                    {idx1==0 && idx==0?<div className="objectLablel"><label>Object Property Value</label></div>:null}
                                                    {/*<select name="confValue" className="form-control chainList left_text1" value={configuration_val.config}*/}
                                                    {/*        onChange={this.changeValue.bind(this, idx, idx1)}>*/}
                                                    {/*    <option value="">None</option>*/}
                                                    {/*    {configuration_val.config_valueList}*/}
                                                    {/*</select>*/}
                                                    {/*{this.state.pricing_logic[idx].config[idx1].configID}*/}
                                                    {/*<AsyncPaginate name="confValue"*/}
                                                    {/*       value={this.state.storeVal}*/}
                                                    {/*       styles={customStyles} className="partyNameList"*/}
                                                    {/*       isClearable={false}*/}
                                                    {/*       onChange={this.changeStore.bind(this)}*/}
                                                    {/*       options = {this.state.storeList1}*/}
                                                    {/*       loadOptions={this.get_config_value.bind(this, idx, idx1,this.state.pricing_logic[idx].config[idx1].configID, this.state.pricing_logic[idx].config[idx1].configTable )}*/}
                                                    {/*       additional={{*/}
                                                    {/*           page: 1,*/}
                                                    {/*       }}*/}
                                                    {/*       placeholder="Select"*/}
                                                    {/*/>*/}
                                                    {/*{config_value}*/}
                                                    <div className="pos-relative">
                                                        <ReactTags
                                                            tags={configuration_val.config_value}
                                                            suggestions={configuration_val.config_valueList}
                                                            handleDelete={this.handleDelete.bind(this, idx, idx1)}
                                                            allowNew={true}
                                                            placeholder={""}
                                                            minQueryLength={1}
                                                            maxSuggestionsLength={30}
                                                            handleInputChange={this.onChangeData.bind(this, idx, idx1, this.state.pricing_logic[idx].config[idx1].config_id, this.state.pricing_logic[idx].config[idx1].configTable, this.state.pricing_logic[idx].config[idx1].configID,)}
                                                            handleAddition={this.handleAddition.bind(this, idx, idx1)}/>
                                                        {/*<Autocomplete*/}
                                                        {/*    items={configuration_val.config_valueList}*/}
                                                        {/*    // shouldItemRender={(item, value) => item.label.indexOf(value) ===0}*/}

                                                        {/*    getItemValue={item => item.id}*/}
                                                        {/*    renderItem={(item, highlighted) =>*/}
                                                        {/*        <div*/}
                                                        {/*            key={item.id}*/}
                                                        {/*            style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}*/}
                                                        {/*        >*/}
                                                        {/*            {item.id}*/}
                                                        {/*        </div>*/}
                                                        {/*    }*/}
                                                        {/*    value={configuration_val.config_value}*/}
                                                        {/*    onChange={this.onChangeData.bind(this,idx, idx1,this.state.pricing_logic[idx].config[idx1].config_id, this.state.pricing_logic[idx].config[idx1].configTable)}*/}
                                                        {/*    onSelect={this.onSelectData.bind(this,idx, idx1)}*/}
                                                        {/*    menuStyle={menuStyle}*/}
                                                        {/*/>*/}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                {/*    <div className="clearfix"></div>*/}
                                {/*</div>*/}
                                {/*<div>*/}

                                    <div className="col-md-1 padd-2">
                                        {idx==0?<div className="objectLablel"><label>Aggregate On</label></div>:null}
                                        <select name="stage_type" className="form-control chainList" value={pricing_val.aggr_id}
                                                onChange={this.changeAggr.bind(this, idx)}>
                                            <option value="">None</option>
                                            {pricing_val.aggrLists}
                                        </select>

                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-1 padd-2">
                                        {idx==0?<div className="objectLablel"><label>Pro-rata for Mid-Month Installation</label></div>:null}
                                        <div><input type="checkbox" name="pro_data_mid" onChange={this.changeProdata.bind(this, idx)} value={pricing_val.pro_data_mid} checked={pricing_val.pro_data_mid}/></div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 padd-2">
                                        {idx==0?<div className="objectLablel"><label>Multiplier<br/> (use 1 for count)</label></div>:null}
                                        <input type="text" value={pricing_val.object_value} name="object_value" className="form-control chainList left_text12" onChange={this.changeObjectValue.bind(this, idx)}/>
                                        <div className="rightMes">
                                            <input type="radio" name={"object_value_type"+idx} value="abs" checked={pricing_val.object_value_type === 'abs'}
                                                   onChange={this.onPerTransactionIf.bind(this, idx)} /> Abs &nbsp;
                                            {pricing_val.objectType == 'fact' ?
                                                <React.Fragment>
                                                    <input type="radio" name={"object_value_type"+idx} value="percent" checked={pricing_val.object_value_type === 'percent'}
                                                           onChange={this.onPerTransactionIf.bind(this, idx)}/> %</React.Fragment> : null}
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                                                    <div className="col-md-1 padd-2">
                                                                        {pricing_val.object_value_type == 'percent' ?
                                            <React.Fragment>
                                                {idx==0?<div className="objectLablel centerText"><label>Measure</label></div>:null}
                                                <div className="ruleText"> Per </div>
                                                <div className="ruleTextList">
                                                    <Select name="measure"
                                                            value={pricing_val.measureVal}
                                                            styles={customStyles} className="partyNameList"
                                                            isClearable={false}
                                                            onChange={this.changeMeasure.bind(this, idx)}
                                                            options={pricing_val.measureLists}
                                                            defaultValue={{ label: "None", value: '' }}
                                                        // placeholder="All"
                                                    />
                                                    {/*<select name="confID" className="form-control chainList left_text1" value=""*/}
                                                    {/*        onChange={this.changeConf.bind(this, idx)}>*/}
                                                    {/*    <option value="">None</option>*/}
                                                    {/*</select>*/}
                                                </div>
                                            </React.Fragment> : null }
                                    </div>
                                                                    <div className="col-md-1 padd-2">
                                                                        <div style={{float:"left", width:"60%"}}>
                                                                        {idx == 0 ?
                                                                            <div className="objectLablel"><label style={{fontSize:"9px"}}>Excel
                                                                                Grouping</label></div> : null}
                                                                        <div><input type="number" value={pricing_val.excel_grouping} name="excel_grouping" className="form-control chainList" style={{width:"90%"}} onChange={this.changeExcelGrouping.bind(this, idx)}/>
                                                                        </div>
                                                                        </div>
                                                                        <div style={{float:"right",width:"40%"}}>
                                                                        {idx == 0 ?
                                                                            <div className="objectLablel"><label style={{fontSize:"9px"}}>Apply
                                                                                pricing</label></div> : null}
                                                                        <div><input type="checkbox" name="apply_pricing"
                                                                                    onChange={this.changeApplyPr.bind(this, idx)}
                                                                                    value={pricing_val.apply_pricing}
                                                                                    checked={pricing_val.apply_pricing}/>
                                                                        </div>
                                                                        </div>
                                                                        <div className="clearfix"></div>
                                                                    </div>
                                    <div className="clearfix"></div>
                                {/*</div>*/}

                                    <br/>
                                </div>
                            ))}
                        </div>
                        <div className="row">

                            <div className="col-md-2">
                                <h5>Pricing Rule :</h5>
                            </div>
                            <div className="col-md-3">
                                <div className="gap_ver"></div>
                                <input type="text" name="pricing_rule_type" value={this.state.pricing_rule_type}
                                       className="form-control chainList"
                                       onChange={this.changeRuleType.bind(this)}/>
                                {/*    <option value="">Pricing Formula</option>*/}
                                {/*    <option value="a">a</option>*/}
                                {/*    <option value="a+b">a+b</option>*/}
                                {/*    <option value="a+b+c">a+b+c</option>*/}
                                {/*</input>*/}
                            </div>
                            {/*<div className="col-md-7">*/}
                            {/*    <div className="gap_ver"></div>*/}
                            {/*    <input type="text" value name="p_logic" className="form-control chainList" onChange={this.changePricingLogic.bind(this)} value={this.state.p_logic}/>*/}

                            {/*</div>*/}
                        </div>
                    </div>

                    <div className="clearfix"></div>
                    <div className="gap_ver"></div>
                    <div className="hoz-line"></div>

                    <div className="clearfix"></div>
                    <div className="gap_ver"></div>
                    <div className="row">
                        <div className="col-md-2 pull-right">
                            {this.state.viewMode === false ?
                                <button type="button" className="btn btn-primary"
                                        onClick={this.checkRule.bind(this)}>Add Rule
                                </button>:
                                null
                            }
                        </div>
                    </div>

                    <div className="">
                        <table id="mdata" className="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th></th>
                                <th width="150px">SKU</th>
                                <th width="100px">Rule Name</th>
                                <th width="100px">Counter Party Type</th>
                                <th>Counter Party Name</th>
                                <th>Counter Party Property</th>
                                <th>Counter Party Value</th>
                                <th>Pricing Logic</th>
                                <th>Description</th>
                                {/*<th>Billing GST Number</th>*/}
                                <th>Valid From</th>
                                <th>Valid Till</th>
                                <th>Status</th>
                                <th>Added by</th>
                                <th>Approved by</th>
                                <th width="50px">Actions</th>
                            </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>

                        {/*{this.state.approve_per===true?*/}
                                <div className="col-md-4 pull-right">
                                    <button type="button" className="btn btn-primary" onClick={this.approveAll.bind(this)}>Approve All</button>&nbsp; &nbsp;
                                    <button type="button" className="btn btn-warning" onClick={this.deleteAll.bind(this)}>Delete All</button>
                                </div>
                        {/*:*/}
                        {/*        */}
                        {/*        <div className="col-md-2 pull-right"><button type="button" className="btn btn-warning" onClick={this.deleteAll.bind(this)}>Delete All</button></div> }*/}
                        {/*    &nbsp; &nbsp;*/}



                    </div>

                    <div className="footer">
                        <div className="stats"><i></i>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default MdataMerchantV2















